import {AttendanceInputSuggestion} from '../attendance/attendanceInputSuggestions'

type Translate = (id: string) => string

function makeSupportSuggestion(
  t: Translate,
  id: string,
  messageId: string
): AttendanceInputSuggestion {
  const label = t(messageId)
  // Headphones on every support chip so it reads as a how-to, not a data query.
  return {id, label, text: label, icon: 'support'}
}

/**
 * Starter chips for a support-only assistant (knowledge base enabled, attendance not),
 * shown under the welcome message. Same shape the attendance chips use so `BotMessage`
 * renders them unchanged. The support-ticket question deliberately sits third.
 */
export function getSupportWelcomeSuggestions(t: Translate): AttendanceInputSuggestion[] {
  return [
    makeSupportSuggestion(t, 'how-to-mark-attendance', 'CHATBOT.FAQ.SUGGEST_MARK_ATTENDANCE'),
    makeSupportSuggestion(t, 'how-to-add-student', 'CHATBOT.FAQ.SUGGEST_ADD_STUDENT'),
    makeSupportSuggestion(t, 'raise-ticket', 'CHATBOT.FAQ.SUGGEST_RAISE_TICKET'),
    makeSupportSuggestion(t, 'how-to-add-exam', 'CHATBOT.FAQ.SUGGEST_SETUP_EXAM'),
  ]
}

/**
 * The single support chip appended after the live attendance examples when both boards
 * are enabled — one how-to among the data questions, so the welcome row shows the
 * assistant does both. The mark-attendance question is the natural companion.
 */
export function getSupportWelcomeSuggestionsForAssistant(
  t: Translate
): AttendanceInputSuggestion[] {
  return [makeSupportSuggestion(t, 'how-to-mark-attendance', 'CHATBOT.FAQ.SUGGEST_MARK_ATTENDANCE')]
}
